import { render } from "./Word.vue?vue&type=template&id=19ef4c56&scoped=true"
import script from "./Word.vue?vue&type=script&lang=js"
export * from "./Word.vue?vue&type=script&lang=js"

import "./Word.vue?vue&type=style&index=0&id=19ef4c56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ef4c56"]])

export default __exports__